import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";

const PALETTE = ["#f43f5e", "#facc15", "#22c55e", "#3b82f6", "#a855f7", "#f97316"];

const beep = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;
  const ctx = new Ctx();
  [523, 659, 784].forEach((f, i) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = f;
    g.gain.setValueAtTime(0.15, ctx.currentTime + i * 0.12);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.12 + 0.2);
    o.connect(g).connect(ctx.destination);
    o.start(ctx.currentTime + i * 0.12);
    o.stop(ctx.currentTime + i * 0.12 + 0.22);
  });
};

export default function FunBurst({ type, trigger }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!trigger || !type) return;
    if (type === "sound") beep();
    setShow(true);
    const t = setTimeout(() => setShow(false), 1200);
    return () => clearTimeout(t);
  }, [trigger, type]);

  return (
    <AnimatePresence>
      {show && (
        <div className="absolute inset-0 pointer-events-none overflow-hidden z-20" data-testid="fun-burst">
          {type === "confetti" && Array.from({ length: 18 }).map((_, i) => (
            <motion.span key={i} className="absolute w-2.5 h-2.5 rounded-sm" style={{ left: "50%", top: "50%", background: PALETTE[i % 6] }}
              initial={{ x: 0, y: 0, opacity: 1, rotate: 0 }} animate={{ x: (Math.random() - 0.5) * 240, y: (Math.random() - 0.5) * 360, opacity: 0, rotate: 360 }} transition={{ duration: 1.1 }} />
          ))}
          {type === "stars" && Array.from({ length: 10 }).map((_, i) => (
            <motion.div key={i} className="absolute" style={{ left: `${8 + i * 9}%`, top: "-10%" }} initial={{ y: 0 }} animate={{ y: 520, rotate: 180 }} transition={{ duration: 1.1, delay: i * 0.04 }}>
              <Star className="w-6 h-6 text-yellow-300 fill-yellow-300" />
            </motion.div>
          ))}
          {type === "dance" && (
            <motion.img src="/img/lumi.webp" alt="" className="absolute bottom-4 right-3 w-20" initial={{ y: 60, rotate: 0 }} animate={{ y: [60, -10, 10, -10, 0], rotate: [0, -15, 15, -15, 0] }} transition={{ duration: 1.1 }} />
          )}
          {type === "sound" && (
            <motion.div className="absolute inset-0 flex items-center justify-center text-5xl font-fredoka font-bold text-white bubble-text" initial={{ scale: 0.4, opacity: 0 }} animate={{ scale: 1.2, opacity: 1 }} exit={{ opacity: 0 }}>
              ♪ ♫
            </motion.div>
          )}
        </div>
      )}
    </AnimatePresence>
  );
}
